import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';

import deserializeFromQueryString from './serializers/queryString/deserialize/deserialize';
import serializeToQueryString from './serializers/queryString/serialize/serialize';

export const convertToQueryString = params => {
    return new URLSearchParams(qs.stringify(serializeToQueryString(params)));
};

const convertFromQueryString = searchParams => {
    return deserializeFromQueryString(qs.parse(searchParams.toString()));
};

export const useQueryParams = (defaultValue, initialNavigate = true) => {
    const history = useHistory();
    const location = useLocation();

    const searchParams = React.useMemo(() => new URLSearchParams(location.search), [location.search]);
    const navigateWithSerialization = React.useCallback(
        (params, options = {}) => {
            const converted = convertToQueryString(params);
            const newSearch = `?${converted.toString()}`;
            if (options.replace) {
                history.replace({
                    pathname: location.pathname,
                    search: newSearch
                });
            } else {
                history.push({
                    pathname: location.pathname,
                    search: newSearch
                });
            }
        },
        [history, location.pathname]
    );

    React.useEffect(() => {
        if (initialNavigate && Object.keys(defaultValue).length > 0 && searchParams.toString() === '') {
            history.replace({
                pathname: location.pathname,
                search: convertToQueryString(defaultValue).toString()
            });
        }
    }, [defaultValue, initialNavigate, history, location.pathname, searchParams]);

    return [React.useMemo(() => convertFromQueryString(searchParams), [searchParams]), navigateWithSerialization];
};
